

// import React from "react";
// import { useNavigate } from "react-router-dom";

// const StaffCustomerList = ({ customers, onEdit, onDelete }) => {
//   const navigate = useNavigate();

//   // ✅ SAFE current user read (NO crash)
//   const currentUser = (() => {
//     try {
//       return JSON.parse(localStorage.getItem("currentUser"));
//     } catch {
//       return null;
//     }
//   })();

//   const thClass =
//     "px-4 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider border-b border-gray-200 bg-gray-50";
//   const tdClass = "px-4 py-4 text-sm text-gray-700 border-b border-gray-100";

//   const btnBase =
//     "px-3 py-1.5 rounded-md text-xs font-bold transition-all duration-200 shadow-sm border";
//   const btnView = `${btnBase} bg-white text-indigo-600 border-indigo-100 hover:bg-indigo-600 hover:text-white`;
//   const btnEdit = `${btnBase} bg-white text-amber-600 border-amber-100 hover:bg-amber-600 hover:text-white`;
//   const btnDelete = `${btnBase} bg-white text-red-600 border-red-100 hover:bg-red-600 hover:text-white`;

//   return (
//     <div
//       style={{ fontFamily: "'Inter', sans-serif" }}
//       className="overflow-x-auto"
//     >
//       <table className="w-full border-collapse min-w-max">
//         <thead>
//           <tr>
//             <th className={thClass}>S.No</th>
//             <th className={thClass}>Created By</th>
//             <th className={thClass}>Code</th>
//             <th className={thClass}>Type</th>
//             <th className={thClass}>Given Date</th>
//             <th className={thClass}>Customer Name</th>
//             <th className={thClass}>Co Name</th>
//             <th className={thClass}>Mobile 1</th>
//             <th className={thClass}>Mobile 2</th>
//             <th className={thClass}>Address</th>
//             <th className={thClass}>Investment</th>
//             <th className={thClass}>Weekly Int.</th>
//             <th className={thClass}>Status</th>
//             <th className={thClass}>Photo</th>
//             <th className={thClass}>Actions</th>
//           </tr>
//         </thead>

//         <tbody className="bg-white">
//           {customers.map((c, index) => (
//             <tr key={c.id} className="hover:bg-gray-50 transition-colors">
//               <td className={`${tdClass} font-mono text-gray-400`}>
//                 {String(index + 1).padStart(2, "0")}
//               </td>

//               <td className={`${tdClass} font-semibold text-indigo-600`}>
//                 {c.created_by || "—"}
//               </td>

//               <td className={`${tdClass} font-semibold text-indigo-700`}>
//                 {c.customer_code}
//               </td>

//               <td className={tdClass}>
//                 <span className="capitalize px-2 py-1 bg-gray-100 rounded text-[10px] font-bold text-gray-600 border border-gray-200">
//                   {c.type}
//                 </span>
//               </td>

//               <td className={`${tdClass} font-medium`}>{c.given_date}</td>

//               <td className={`${tdClass} font-bold text-gray-900`}>{c.name}</td>

//               <td className={tdClass}>{c.co_name}</td>

//               <td className={`${tdClass} font-medium`}>{c.mobile1}</td>

//               <td className={`${tdClass} text-gray-500`}>{c.mobile2 || "-"}</td>

//               <td
//                 className={`${tdClass} max-w-xs truncate text-xs text-gray-500`}
//                 title={c.address}
//               >
//                 {c.address}
//               </td>

//               <td className={`${tdClass} font-bold text-green-700`}>
//                 ₹{Number(c.investment_amount).toLocaleString()}
//               </td>

//               <td className={`${tdClass} font-bold text-blue-700`}>
//                 ₹{Number(c.weekly_interest_amount).toLocaleString()}
//               </td>

//               <td className={tdClass}>
//                 <span
//                   className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${
//                     c.status === "Active"
//                       ? "bg-green-100 text-green-800"
//                       : "bg-red-100 text-red-800"
//                   }`}
//                 >
//                   {c.status}
//                 </span>
//               </td>

//               <td className={tdClass}>
//                 {c.photo_url ? (
//                   <img
//                     src={c.photo_url}
//                     alt="ID"
//                     className="w-10 h-10 rounded shadow-sm object-cover border border-gray-200"
//                   />
//                 ) : (
//                   <div className="w-10 h-10 rounded bg-gray-50 flex items-center justify-center text-[10px] text-gray-400 border border-dashed border-gray-300">
//                     N/A
//                   </div>
//                 )}
//               </td>

//               <td className={`${tdClass} whitespace-nowrap`}>
//                 <div className="flex items-center gap-2">
//                   <button
//                     onClick={() => navigate(`/staff/customers/${c.id}`)}
//                     className={btnView}
//                   >
//                     View
//                   </button>

                 
//                 </div>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default StaffCustomerList;




// import React from "react";
// import { useNavigate } from "react-router-dom";


// const StaffCustomerList = ({ customers, onEdit, onDelete }) => {
//   const navigate = useNavigate();

//   // ✅ SAFE current user read (NO crash)
//   const currentUser = (() => {
//     try {
//       return JSON.parse(localStorage.getItem("currentUser"));
//     } catch {
//       return null;
//     }
//   })();

//   const thClass =
//     "px-4 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider border-b border-gray-200 bg-gray-50";
//   const tdClass = "px-4 py-4 text-sm text-gray-700 border-b border-gray-100";

//   const btnBase =
//     "px-3 py-1.5 rounded-md text-xs font-bold transition-all duration-200 shadow-sm border";
//   const btnView = `${btnBase} bg-white text-indigo-600 border-indigo-100 hover:bg-indigo-600 hover:text-white`;
//   const btnEdit = `${btnBase} bg-white text-amber-600 border-amber-100 hover:bg-amber-600 hover:text-white`;
//   const btnDelete = `${btnBase} bg-white text-red-600 border-red-100 hover:bg-red-600 hover:text-white`;


//   const formatDateMMDDYYYY = (dateStr) => {
//     if (!dateStr) return "—";

//     const date = new Date(dateStr);
//     if (isNaN(date)) return dateStr;

//     const mm = String(date.getMonth() + 1).padStart(2, "0");
//     const dd = String(date.getDate()).padStart(2, "0");
//     const yyyy = date.getFullYear();

//     return `${mm}-${dd}-${yyyy}`;
//   };


//   return (
//     <div
//       style={{ fontFamily: "'Inter', sans-serif" }}
//       className="overflow-x-auto"
//     >
//       <table className="w-full border-collapse min-w-max">
//         <thead>
//           <tr>
//             <th className={thClass}>S.No</th>
//             <th className={thClass}>Created By</th>
//             <th className={thClass}>Code</th>
//             <th className={thClass}>Type</th>
//             <th className={thClass}>Loan Date</th>
//             <th className={thClass}>Customer Name</th>
//             <th className={thClass}>Co Name</th>
//             <th className={thClass}>Mobile 1</th>
//             <th className={thClass}>Mobile 2</th>
//             <th className={thClass}>Address</th>
//             <th className={thClass}>Investment</th>
//             <th className={thClass}>Weekly Int.</th>
//             <th className={thClass}>Status</th>
//             <th className={thClass}>Photo</th>
//             <th className={thClass}>Actions</th>
//           </tr>
//         </thead>

//         <tbody className="bg-white">
//           {customers.map((c, index) => (
//             <tr key={c.id} className="hover:bg-gray-50 transition-colors">
//               <td className={`${tdClass} font-mono text-gray-400`}>
//                 {String(index + 1).padStart(2, "0")}
//               </td>

//               <td className={`${tdClass} font-semibold text-indigo-600`}>
//                 {c.created_by || "—"}
//               </td>

//               <td className={`${tdClass} font-semibold text-indigo-700`}>
//                 {c.customer_code}
//               </td>

//               <td className={tdClass}>
//                 <span className="capitalize px-2 py-1 bg-gray-100 rounded text-[10px] font-bold text-gray-600 border border-gray-200">
//                   {c.type}
//                 </span>
//               </td>

//               {/* <td className={`${tdClass} font-medium`}>{c.given_date}</td> */}
//               <td className={`${tdClass} font-medium`}>
//                 {formatDateMMDDYYYY(c.given_date)}
//               </td>

//               <td className={`${tdClass} font-bold text-gray-900`}>{c.name}</td>

//               <td className={tdClass}>{c.co_name}</td>

//               <td className={`${tdClass} font-medium`}>{c.mobile1}</td>

//               <td className={`${tdClass} text-gray-500`}>{c.mobile2 || "-"}</td>

//               <td
//                 className={`${tdClass} max-w-xs truncate text-xs text-gray-500`}
//                 title={c.address}
//               >
//                 {c.address}
//               </td>

//               <td className={`${tdClass} font-bold text-green-700`}>
//                 ₹{Number(c.investment_amount).toLocaleString()}
//               </td>

//               <td className={`${tdClass} font-bold text-blue-700`}>
//                 ₹{Number(c.weekly_interest_amount).toLocaleString()}
//               </td>

//               <td className={tdClass}>
//                 <span
//                   className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${
//                     c.status === "Active"
//                       ? "bg-green-100 text-green-800"
//                       : "bg-red-100 text-red-800"
//                   }`}
//                 >
//                   {c.status}
//                 </span>
//               </td>

//               <td className={tdClass}>
//                 {c.photo_url ? (
//                   <img
//                     src={c.photo_url}
//                     alt="ID"
//                     className="w-10 h-10 rounded shadow-sm object-cover border border-gray-200"
//                   />
//                 ) : (
//                   <div className="w-10 h-10 rounded bg-gray-50 flex items-center justify-center text-[10px] text-gray-400 border border-dashed border-gray-300">
//                     N/A
//                   </div>
//                 )}
//               </td>

//               <td className={`${tdClass} whitespace-nowrap`}>
//                 <div className="flex items-center gap-2">
//                   <button
//                     onClick={() => navigate(`/staff/customers/${c.id}`)}
//                     className={btnView}
//                   >
//                     View
//                   </button>

//                   {/* <button onClick={() => onEdit(c)} className={btnEdit}>
//                     Edit
//                   </button> */}

//                   {/* ✅ DELETE ONLY FOR ADMIN OR CREATOR */}
//                   {/* {(currentUser?.role === "admin" ||
//                     currentUser?.username === c.created_by) && (
//                     <button
//                       onClick={() => onDelete(c.id)}
//                       className={btnDelete}
//                     >
//                       Delete
//                     </button>
//                   )} */}
//                 </div>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default StaffCustomerList;





import React, { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Api } from "../Api/Api";


const StaffCustomerList = ({ customers, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
const [type, setType] = useState("all");
const [types, setTypes] = useState([]);

  const thClass =
    "px-4 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider border-b border-gray-200 bg-gray-50";
  const tdClass = "px-4 py-4 text-sm text-gray-700 border-b border-gray-100";

  const btnBase =
    "px-3 py-1.5 rounded-md text-xs font-bold transition-all duration-200 shadow-sm border";
  const btnView = `${btnBase} bg-white text-indigo-600 border-indigo-100 hover:bg-indigo-600 hover:text-white`;
  const btnEdit = `${btnBase} bg-white text-amber-600 border-amber-100 hover:bg-amber-600 hover:text-white`;
  const btnDelete = `${btnBase} bg-white text-red-600 border-red-100 hover:bg-red-600 hover:text-white`;


  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "—";

    const date = new Date(dateStr);
    if (isNaN(date)) return dateStr;

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  };


  useEffect(() => {
  loadTypes();
}, []);

const loadTypes = async () => {
  try {
    const res = await fetch(`${Api}customers/types/list.php`);
    const data = await res.json();
    setTypes(data.types || []);
  } catch (err) {
    console.error("Failed to load customer types", err);
  }
};




const filteredCustomers = useMemo(() => {
  const q = search.toLowerCase();

  return customers.filter((c) => {
    const matchesSearch =
      c.name?.toLowerCase().includes(q) ||
      c.customer_code?.toLowerCase().includes(q);

    const matchesType = type === "all" || c.type === type;

    return matchesSearch && matchesType;
  });
}, [search, type, customers]);


  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }} className="space-y-4">
      <div className="flex flex-col sm:flex-row gap-4 items-center px-4 pt-4">
        {/* 🔍 Search */}
        <input
          type="text"
          placeholder="Search by Customer Name or Code..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full sm:max-w-md px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none"
        />

        {/* 🔽 Type Filter (FROM BACKEND) */}
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-bold bg-white"
        >
          <option value="all">All Types</option>
          {types.map((t) => (
            <option key={t.id} value={t.type_name}>
              {t.type_name}
            </option>
          ))}
        </select>

        <span className="text-sm text-gray-500 font-medium">
          {filteredCustomers.length} results
        </span>
      </div>

      {/* 📋 Table */}
      {/* <div className="overflow-x-auto"> */}
      <div className="overflow-x-auto overflow-y-auto max-h-[70vh] border rounded-lg shadow">
        {/* <table className="w-full border-collapse min-w-max"> */}
        <table className="border-collapse text-sm min-w-[1400px] w-full">
          <thead>
            <tr>
              <th className={thClass}>S.No</th>
              <th className={thClass}>Created By</th>
              <th className={thClass}>Code</th>
              <th className={thClass}>Type</th>
              <th className={thClass}>Loan Date</th>
              <th className={thClass}>Customer Name</th>
              <th className={thClass}>Co Name</th>
              <th className={thClass}>Mobile 1</th>
              <th className={thClass}>Mobile 2</th>
              <th className={thClass}>Address</th>
              <th className={thClass}>Investment</th>
              <th className={thClass}>Weekly Int.</th>
              <th className={thClass}>Status</th>
              <th className={thClass}>Photo</th>
              <th className={thClass}>Actions</th>
            </tr>
          </thead>

          <tbody className="bg-white">
            {filteredCustomers.length === 0 ? (
              <tr>
                <td
                  colSpan="15"
                  className="text-center py-10 text-gray-400 font-medium"
                >
                  No matching customers found
                </td>
              </tr>
            ) : (
              filteredCustomers.map((c, index) => (
                <tr key={c.id} className="hover:bg-gray-50 transition-colors">
                  <td className={`${tdClass} font-mono text-gray-400`}>
                    {String(index + 1).padStart(2, "0")}
                  </td>

                  <td className={`${tdClass} font-semibold text-indigo-600`}>
                    {c.created_by || "—"}
                  </td>

                  <td className={`${tdClass} font-semibold text-indigo-700`}>
                    {c.customer_code}
                  </td>

                  <td className={tdClass}>
                    <span className="capitalize px-2 py-1 bg-gray-100 rounded text-[10px] font-bold text-gray-600 border">
                      {c.type}
                    </span>
                  </td>

                  <td className={`${tdClass} font-medium`}>
                    {/* {formatDateMMDDYYYY(c.given_date)} */}
                    {formatDateDDMMYYYY(c.given_date)}
                  </td>

                  <td className={`${tdClass} font-bold text-gray-900`}>
                    {c.name}
                  </td>

                  <td className={tdClass}>{c.co_name}</td>
                  <td className={`${tdClass} font-medium`}>{c.mobile1}</td>
                  <td className={`${tdClass} text-gray-500`}>
                    {c.mobile2 || "-"}
                  </td>

                  <td
                    className={`${tdClass} max-w-xs truncate text-xs text-gray-500`}
                    title={c.address}
                  >
                    {c.address}
                  </td>

                  <td className={`${tdClass} font-bold text-green-700`}>
                    ₹{Number(c.investment_amount).toLocaleString()}
                  </td>

                  <td className={`${tdClass} font-bold text-blue-700`}>
                    ₹{Number(c.weekly_interest_amount).toLocaleString()}
                  </td>

                  <td className={tdClass}>
                    <span
                      className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${
                        c.status === "Active"
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      {c.status}
                    </span>
                  </td>

                  <td className={tdClass}>
                    {c.photo_url ? (
                      <img
                        src={c.photo_url}
                        alt="ID"
                        className="w-10 h-10 rounded object-cover border"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded bg-gray-100 flex items-center justify-center text-xs text-gray-400">
                        N/A
                      </div>
                    )}
                  </td>

                  <td className={`${tdClass} whitespace-nowrap`}>
                    <div className="flex gap-2">
                      <button
                        onClick={() => navigate(`/staff/customers/${c.id}`)}
                        className={btnView}
                      >
                        View
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StaffCustomerList;
